import { GridItem } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import MaterialSelectionPanel from "components/form/MaterialSelectionPanel";

import useProductMaterialSelectionForm from "hooks/form/useProductMaterialSelectionForm";

function ProductMaterialForm({ productId }: { productId: string }) {
    const selectionHook = useProductMaterialSelectionForm({ productId });

    return (
        <GridItem className="product-container">
            <Paper>
                <MaterialSelectionPanel selectionHook={selectionHook} />
            </Paper>
        </GridItem>
    );
}

export default ProductMaterialForm;
